import { faChevronCircleLeft, faChevronCircleRight, faCircle } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useEffect, useState } from "react"
import "./imageSlider.scss"

const images = [
    {
        text: "Foundry Services for Custom Castings",
        url: "https://res.cloudinary.com/dobxtcf1w/image/upload/v1730788188/foundry_banner.jpg_g0uiss.jpg"
    },
    {
        text: "Gas & Oil-Fired Tilting Furnace",
        url: "https://res.cloudinary.com/dobxtcf1w/image/upload/v1730786775/furnace_banner_quicsb.jpg"
    },
    {
        text: "Induction Furnace for Steel & Non-Ferrous Alloys",
        url: "https://res.cloudinary.com/dobxtcf1w/image/upload/v1730788667/induction_furnace_banner_bfmgwt.jpg"
    },
]
const ImageSlider = () =>{

    const [imgNum, setImgNum] = useState(0)
    // const [activeCircle, setActiveCircle] = useState("active")

    const changeImg= () => {setImgNum((prevState)=>(prevState + 1)%3) }
    useEffect(()=>
        { const timer = setTimeout(()=>{
            changeImg()
        }, 7000)
        return () => clearTimeout(timer);
    } , [imgNum])

    const toPrev =()=>{
        const isFirstSlide = imgNum === 0;
        const newImg = isFirstSlide ? images.length-1 : imgNum - 1;
        setImgNum(newImg);
    }

    const toNext =()=>{
        const isLastSlide = imgNum === images.length - 1;
        const newImg = isLastSlide ? 0 : imgNum + 1;
        setImgNum(newImg);
    }


    return(
        <div className="imageslider">
            <div className="text">{images[imgNum].text}</div>
            <div className="left__arrow" onClick={toPrev}>
                <FontAwesomeIcon icon ={faChevronCircleLeft}/>
            </div>
            <img src = {images[imgNum].url} alt = "raydron_banner" className="slider"/>
            <div className="right__arrow" onClick={toNext}>
            <FontAwesomeIcon icon ={faChevronCircleRight}/>
            </div>
            <div className="dots">
                {images.map((image, index)=>(
                    <div className={imgNum === index ? "dot active" : "dot"} key = {index} onClick={()=>setImgNum(index)}><FontAwesomeIcon icon ={faCircle}/></div>
                )

                )}
            </div>
        </div>
    )
}

export default ImageSlider